import { render, staticRenderFns } from "./common_head.vue?vue&type=template&id=328ddf65&scoped=true&"
import script from "./common_head.vue?vue&type=script&lang=js&"
export * from "./common_head.vue?vue&type=script&lang=js&"
import style0 from "./common_head.css?vue&type=style&index=0&id=328ddf65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328ddf65",
  null
  
)

export default component.exports